(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/bank/assets/javascripts/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/ui/bank/assets/javascripts/helpers/handlebars-helpers.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


(function (svs) {
  'use strict';

  var shared;

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    shared = require('../shared.es6');
    registerHelpers(require('hbs'));
  } else {
    shared = svs.ui.bank;
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('ui_bank_getIMG', function (name, size) {
      var options = arguments[arguments.length - 1],
          urls = shared.getIMG(name, size);
      return options.fn(this, {
        data: options.data,
        blockParams: urls
      });
    });
  }
})(svs);
 })(window);